import { render, staticRenderFns } from "./ByRoles.vue?vue&type=template&id=153f94c9&lang=pug"
import script from "./ByRoles.vue?vue&type=script&lang=js"
export * from "./ByRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports